import { ApiBase, ApiResponse } from '../api-base';
import { inject } from 'aurelia';
import { IHttpClient } from '@aurelia/fetch-client';
import { ScheduleEntity } from './schedule-entity';

@inject(IHttpClient)
export class ScheduleApi extends ApiBase {

    constructor(http: IHttpClient) {
        super(http);
    }

    public async add(eventId: string, entity: ScheduleEntity): Promise<ScheduleEntity> {
        const dto = entity.toDto();
        const response = await this.post(this._baseUrl(eventId), dto);
        return ScheduleEntity.fromDto(response.content);
    }

    public async update(eventId: string, id: string, entity: ScheduleEntity): Promise<ScheduleEntity> {
        const dto = entity.toDto();
        const response = await this.patch(this._baseUrlWithId(eventId, id), dto);
        return ScheduleEntity.fromDto(response.content);
    }

    public async getById(eventId: string, id: string): Promise<ScheduleEntity> {
        const response = await this.get(this._baseUrlWithId(eventId, id));
        return ScheduleEntity.fromDto(response.content);
    }

    public async listByEventId(eventId: string): Promise<ScheduleEntity[]> {
        const response = await this.get(this._baseUrl(eventId));
        return ScheduleEntity.fromDtoArray(response.content);
    }

    public async deleteById(eventId: string, id: string): Promise<ApiResponse> {
        const response = await this.delete(this._baseUrlWithId(eventId, id));
        return response;
    }
    // public async getByCode(code: string): Promise<ScheduleEntity> {
    //   const response = await this.get(this._getByTokenBaseUrl + '/?code=' + code);
    //   return ScheduleEntity.fromDto(response.content);
    // }

    // public async getByToken(code: string, token: string): Promise<ScheduleEntity> {
    //   const response = await this.get(this._getByTokenBaseUrl + '/bytoken', {code, token});
    //   return ScheduleEntity.fromDto(response.content);
    // }

    // public async getByPin(code: string, pin: string): Promise<ScheduleEntity> {
    //   const dto = {
    //     code,
    //     pin
    //   };
    //   const response = await this.post(this._baseUrl + '/bypin', dto);
    //   return ScheduleEntity.fromDto(response.content);
    // }

    // private get _getByTokenBaseUrl(): string {
    //   return `api/schedules/`;
    // }
    private _baseUrlWithId(eventId: string, id: string): string {
        return `api/events/${eventId}/schedules/${id}`;
    }
    private _baseUrl(eventId: string): string {
        return `api/events/${eventId}/schedules`;
    }
}
